import { dayJs } from './dayjs'
import { getFormattedDateRange } from './get-formatted-date-range'

// A single date is a range that starts and ends on the same day, so it reuses
// the range formatter rather than repeating its locale rules. The input is
// pinned to Amsterdam midnight first: a stored value may carry a time
// ("2026-09-08T20:00:00Z") which would otherwise come back out as
// "8 September 2026, 20:00–20:00". Keeping the explicit offset in the string
// means the day is picked in Amsterdam, not in whatever zone the server runs.
export const getFormattedDate = (dateInput: string, options?: { forceYear?: boolean }) => {
  if (!dateInput) {
    return ''
  }

  const dayjs = dayJs()
  const startOfDay = dayjs(dateInput).tz('Europe/Amsterdam').startOf('day').format('YYYY-MM-DDTHH:mm:ssZ')

  return getFormattedDateRange(startOfDay, startOfDay, options)
}
